import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatContractedKoreanBusinessList,
	formatForeignDashboardStatistic,
} from './foreign-dashboard.helper';
import { ForeignDashboardActions } from './foreign-dashboard.redux';
import {
	IPayloadGetContractedKoreanBusinessListRequest,
	IPayloadGetForeignDashboardStatisticRequest,
} from './foreign-dashboard.type';

export function* getForeignDashboardStatistic(
	action: PayloadAction<IPayloadGetForeignDashboardStatisticRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetForeignDashboardStatisticResponse> =
			yield API.getForeignDashboardStatistic(rest);
		const foreignDashboardStatistic = formatForeignDashboardStatistic(
			res?.data
		);

		yield put(
			ForeignDashboardActions.getForeignDashboardStatisticSuccess({
				foreignDashboardStatistic: foreignDashboardStatistic,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignDashboardActions.getForeignDashboardStatisticFailure());
	}
}

export function* getContractedKoreanBusiness(
	action: PayloadAction<IPayloadGetContractedKoreanBusinessListRequest>
) {
	const { callback, page, pageSize, allData } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetContractedKoreanBusinessResponse> =
			yield API.getContractedKoreanBusiness({
				page,
				pageSize,
				allData,
			});
		const data = formatContractedKoreanBusinessList(res?.data);
		const total = res?.data?.total;

		yield put(
			ForeignDashboardActions.getContractedKoreanBusinessListSuccess({
				content: data?.content,
				total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignDashboardActions.getContractedKoreanBusinessListFailure());
	}
}
